<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>

        <section class="dp-right">
            <div class="led-toolbar">
                <el-select v-model="filters.campusId" placeholder="全部校区" clearable size="small" style="width: 180px"
                    @change="handleSearch">
                    <el-option v-for="item in campusOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
                <el-input v-model="filters.keyword" placeholder="校门名称 / MAC" clearable size="small" style="width: 220px"
                    @keyup.enter.native="handleSearch" @clear="handleSearch" />
                <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
                <el-button type="success" size="small" icon="el-icon-plus" @click="handleAdd">新增设备</el-button>
            </div>
            <div class="dp-dept-hint">
                <span class="dp-dept-hint__label">所属机构</span>
                <span class="dp-dept-hint__value">{{ currentDepartmentName || '请选择学校' }}</span>
                <span class="led-hint">在线状态与 IP 由 LED 服务心跳自动回写，仅供参考；叫号以实际下发结果为准。</span>
            </div>
            <div class="tbl-scroll-host">
                <el-table v-loading="listLoading" :data="list" height="100%" style="width: 100%" highlight-current-row>
                    <el-table-column type="index" width="50" label="序号" align="center" />
                    <el-table-column prop="CampusName" label="校区" align="center" min-width="120" />
                    <el-table-column prop="GateName" label="校门" align="center" min-width="100" />
                    <el-table-column label="控制卡 MAC" align="center" min-width="150">
                        <template slot-scope="scope">
                            <span class="mono">{{ formatMac(scope.row.DeviceMac) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="启用" align="center" width="80">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.IsEnabled ? 'success' : 'info'" size="mini">
                                {{ scope.row.IsEnabled ? '启用' : '停用' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="语音" align="center" width="80">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.EnableVoice ? '' : 'info'" size="mini">
                                {{ scope.row.EnableVoice ? '播报' : '静音' }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="在线" align="center" width="90">
                        <template slot-scope="scope">
                            <span class="online-dot" :class="{ 'is-online': scope.row.IsOnline }"></span>
                            {{ scope.row.IsOnline ? '在线' : '离线' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="最近心跳" align="center" min-width="140">
                        <template slot-scope="scope">{{ formatTime(scope.row.LastHeartbeatTime) }}</template>
                    </el-table-column>
                    <!-- <el-table-column prop="CurrentIp" label="当前 IP" align="center" min-width="120" /> -->
                    <el-table-column prop="Remark" label="备注" align="center" min-width="120" show-overflow-tooltip />
                    <el-table-column label="操作" width="230" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" @click="openCommand(scope.row)">下发</el-button>
                            <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                            <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="pagination-container">
                <el-pagination layout="total, prev, pager, next" :current-page="page" :page-size="pageSize" :total="total"
                    @current-change="handleCurrentChange" style="float: right" />
            </div>

            <el-dialog :title="temp.Id ? '编辑校门 LED' : '新增校门 LED'" :visible.sync="dialogVisible" width="560px"
                :close-on-click-modal="false">
                <el-form ref="dataForm" :model="temp" :rules="rules" label-width="110px" style="padding-right: 20px">
                    <el-form-item label="所属校区" prop="CampusId">
                        <el-select v-model="temp.CampusId" placeholder="请选择校区" style="width: 100%">
                            <el-option v-for="item in campusOptions" :key="item.value" :label="item.label"
                                :value="item.value" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="校门名称" prop="GateName">
                        <el-input v-model="temp.GateName" maxlength="50" placeholder="如：东门" />
                    </el-form-item>
                    <el-form-item label="控制卡 MAC" prop="DeviceMac">
                        <el-input v-model="temp.DeviceMac" placeholder="如 XX-XX-XX-XX-7B-E5，保存时自动统一格式" />
                    </el-form-item>
                    <el-form-item label="是否启用">
                        <el-switch v-model="temp.IsEnabled" active-text="启用" inactive-text="停用" />
                    </el-form-item>
                    <el-form-item label="是否语音">
                        <el-switch v-model="temp.EnableVoice" active-text="播报" inactive-text="静音" />
                        <div class="form-tip">关闭后只显示班级放学文字、不发声，文字保留到下一个班或切回时钟。</div>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="temp.Remark" type="textarea" :rows="2" maxlength="500" />
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取消</el-button>
                    <el-button type="primary" :loading="submitLoading" @click="saveData">确认</el-button>
                </div>
            </el-dialog>

            <el-dialog title="下发指令" :visible.sync="commandVisible" width="640px" :close-on-click-modal="false">
                <div v-if="commandDevice" class="cmd-device">
                    <span>{{ commandDevice.GateName || '未命名校门' }}</span>
                    <span class="mono">{{ formatMac(commandDevice.DeviceMac) }}</span>
                    <span class="online-dot" :class="{ 'is-online': commandDevice.IsOnline }"></span>
                    <span>{{ commandDevice.IsOnline ? '在线' : '离线' }}</span>
                </div>
                <div class="cmd-modes" role="tablist" aria-label="下发方式">
                    <button v-for="item in commandModes" :key="item.value" type="button" class="cmd-mode"
                        role="tab" :aria-selected="commandForm.mode === item.value"
                        :class="{ 'is-active': commandForm.mode === item.value }"
                        @click="commandForm.mode = item.value">{{ item.label }}</button>
                </div>
                <div class="cmd-stage">
                    <el-input v-if="commandForm.mode !== 'program'" v-model="commandForm.text" type="textarea"
                        maxlength="32" show-word-limit resize="none"
                        placeholder="例如：一年级1班正在放学，请家长在等候区等待" />
                    <div v-else class="cmd-program" role="radiogroup" aria-label="切换节目">
                        <button v-for="item in programOptions" :key="item.value" type="button" class="cmd-program-card"
                            role="radio" :aria-checked="commandForm.programNo === item.value"
                            :class="{ 'is-active': commandForm.programNo === item.value }"
                            @click="commandForm.programNo = item.value">
                            <span class="cmd-program-no">节目 {{ item.value }}</span>
                            <span class="cmd-program-name">{{ item.name }}</span>
                            <span class="cmd-program-desc">{{ item.desc }}</span>
                        </button>
                    </div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="commandVisible = false">取消</el-button>
                    <el-button type="primary" :loading="commandLoading" @click="submitCommand">立即下发</el-button>
                </div>
            </el-dialog>
        </section>
    </section>
</template>

<script>
import { getLedDeviceList, saveLedDevice, deleteLedDevice, sendLedCommand } from "@/api/dismissal";
import { getCampusList } from "../../api/modules/misc";
import DepartmentPane from "../../components/DepartmentPane";
import { treeNodeDeptId } from '../../utils/deptCascaderProps';

/**
 * 校门 LED 叫号设备档案（与浏览器放学大屏独立）。创建于 2026-09-30
 */
export default {
    name: "LedDeviceManager",
    components: { DepartmentPane },
    data() {
        const macValidator = (rule, value, callback) => {
            const mac = String(value || "").replace(/[-:\s]/g, "");
            if (!/^[0-9a-fA-F]{12}$/.test(mac)) {
                callback(new Error("MAC 应为 12 位十六进制"));
            } else {
                callback();
            }
        };
        return {
            currentDeptId: "",
            currentDepartmentName: "",
            campusOptions: [],
            filters: { campusId: "", keyword: "" },
            list: [],
            listLoading: false,
            page: 1,
            pageSize: 10,
            total: 0,
            dialogVisible: false,
            submitLoading: false,
            commandVisible: false,
            commandLoading: false,
            commandDevice: null,
            commandModes: [
                { value: "both", label: "文字+语音" },
                { value: "voice", label: "仅语音" },
                { value: "display", label: "仅文字" },
                { value: "program", label: "切换节目" },
            ],
            programOptions: [
                { value: 1, name: "放学文字", desc: "切到内码节目，不改文字、不播语音" },
                { value: 5, name: "时钟", desc: "切回时钟画面，不改文字、不播语音" },
            ],
            commandForm: { mode: "both", text: "一年级1班正在放学，请家长在等候区等待", programNo: 1 },
            temp: this.emptyTemp(),
            rules: {
                CampusId: [{ required: true, message: "请选择校区", trigger: "change" }],
                DeviceMac: [
                    { required: true, message: "请输入控制卡 MAC", trigger: "blur" },
                    { validator: macValidator, trigger: "blur" },
                ],
            },
        };
    },
    methods: {
        /** 空表单 */
        emptyTemp() {
            return {
                Id: 0,
                CampusId: "",
                GateName: "",
                DeviceMac: "",
                IsEnabled: true,
                EnableVoice: true,
                Remark: "",
            };
        },
        /** 左侧机构树点击：加载校区与设备列表 */
        treeNodeClick(data) {
            if (!data || !data.value || data.value == "0") {
                this.$message.warning("请选择具体的学校或校区");
                this.currentDeptId = "";
                this.currentDepartmentName = "";
                this.list = [];
                this.total = 0;
                this.campusOptions = [];
                return;
            }
            this.currentDeptId = treeNodeDeptId(data) || String(data.value);
            this.currentDepartmentName = data.label;
            this.filters.campusId = "";
            this.page = 1;
            this.fetchCampuses();
            this.handleQuery();
        },
        /**
         * 拉取校区选项（学校节点返回全部校区，校区节点只返回自身）
         * @returns {Promise<void>}
         */
        fetchCampuses() {
            return getCampusList({ page: 1, intPageSize: 999, departmentId: this.currentDeptId })
                .then((res) => {
                    const rows = res.data.success && res.data.response ? res.data.response.data || [] : [];
                    this.campusOptions = rows.map((d) => ({ label: d.Name, value: String(d.Id) }));
                })
                .catch(() => {
                    this.campusOptions = [];
                });
        },
        handleSearch() {
            this.page = 1;
            this.handleQuery();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.handleQuery();
        },
        /** 查询设备列表 */
        handleQuery() {
            if (!this.currentDeptId) return;
            this.listLoading = true;
            getLedDeviceList({
                departmentId: this.currentDeptId,
                campusId: this.filters.campusId || 0,
                keyword: this.filters.keyword || "",
                page: this.page,
                intPageSize: this.pageSize,
            })
                .then((res) => {
                    if (res.data.success && res.data.response) {
                        this.list = res.data.response.data || [];
                        this.total = res.data.response.dataCount || 0;
                    } else {
                        this.list = [];
                        this.total = 0;
                        if (res.data.msg) this.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    this.list = [];
                    this.total = 0;
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        handleAdd() {
            if (!this.currentDeptId) {
                this.$message.warning("请先选择左侧学校/校区");
                return;
            }
            this.temp = this.emptyTemp();
            if (this.campusOptions.length === 1) {
                this.temp.CampusId = this.campusOptions[0].value;
            }
            this.dialogVisible = true;
            this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate());
        },
        handleEdit(row) {
            this.temp = {
                Id: row.Id,
                CampusId: row.CampusId ? String(row.CampusId) : "",
                GateName: row.GateName || "",
                DeviceMac: this.formatMac(row.DeviceMac),
                IsEnabled: !!row.IsEnabled,
                EnableVoice: !!row.EnableVoice,
                Remark: row.Remark || "",
            };
            this.dialogVisible = true;
            this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate());
        },
        /** 保存设备 */
        saveData() {
            this.$refs.dataForm.validate((valid) => {
                if (!valid) return;
                this.submitLoading = true;
                saveLedDevice({ ...this.temp, SchoolId: this.currentDeptId })
                    .then((res) => {
                        if (res.data.success) {
                            this.$message.success("保存成功");
                            this.dialogVisible = false;
                            this.handleQuery();
                        } else {
                            this.$message.error(res.data.msg || "保存失败");
                        }
                    })
                    .catch(() => this.$message.error("保存异常"))
                    .finally(() => {
                        this.submitLoading = false;
                    });
            });
        },
        /** 打开单台设备下发弹窗 */
        openCommand(row) {
            this.commandDevice = row;
            this.commandForm = {
                mode: "both",
                text: "一年级1班正在放学，请家长在等候区等待",
                programNo: 1,
            };
            this.commandVisible = true;
        },
        /** 经业务平台转发到 LedLamp */
        submitCommand() {
            if (!this.commandDevice || !this.currentDeptId) return;
            const mode = this.commandForm.mode;
            const text = (this.commandForm.text || "").trim();
            if (mode !== "program" && !text) {
                this.$message.warning(mode === "voice" ? "请输入播报内容" : "请输入显示文字");
                return;
            }
            if (mode !== "program" && text.length > 32) {
                this.$message.warning("最多 32 个字，与 LED 屏显示一致");
                return;
            }
            this.commandLoading = true;
            sendLedCommand({
                Id: this.commandDevice.Id,
                DepartmentId: this.currentDeptId,
                Mode: mode,
                Text: text,
                ProgramNo: this.commandForm.programNo,
            })
                .then((res) => {
                    if (res.data.success) {
                        this.$message.success(res.data.msg || "下发成功");
                        this.commandVisible = false;
                    } else {
                        this.$message.error(res.data.msg || "下发失败");
                    }
                })
                .catch(() => this.$message.error("下发异常"))
                .finally(() => {
                    this.commandLoading = false;
                });
        },
        handleDel(row) {
            const label = row.GateName || this.formatMac(row.DeviceMac);
            this.$confirm(`确认删除校门 LED「${label}」？删除后不再参与叫号。`, "提示", { type: "warning" })
                .then(() => deleteLedDevice({ id: row.Id }))
                .then((res) => {
                    if (res && res.data && res.data.success) {
                        this.$message.success("删除成功");
                        this.handleQuery();
                    } else if (res) {
                        this.$message.error(res.data.msg || "删除失败");
                    }
                })
                .catch(() => {});
        },
        /** 标准化 MAC（9498a2477be5）展示为 94-98-A2-47-7B-E5 */
        formatMac(mac) {
            const s = String(mac || "").replace(/[-:\s]/g, "").toUpperCase();
            if (s.length !== 12) return mac || "";
            return s.match(/.{2}/g).join("-");
        },
        formatTime(time) {
            if (!time || String(time).startsWith("0001")) return "-";
            const d = new Date(time);
            const p = (n) => String(n).padStart(2, "0");
            return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
        },
    },
};
</script>

<style scoped>
.led-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 0;
    flex-wrap: wrap;
}
.led-hint {
    margin-left: 16px;
    color: #909399;
    font-size: 12px;
}
.mono {
    font-family: Consolas, Monaco, monospace;
    letter-spacing: 0.5px;
}
.online-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 4px;
    border-radius: 50%;
    background: #c0c4cc;
    vertical-align: middle;
}
.online-dot.is-online {
    background: #10b981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.18);
}
.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 18px;
}
.cmd-device {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    padding: 8px 12px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    color: #334155;
}
.cmd-modes {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 4px;
    margin-bottom: 14px;
    padding: 4px;
    background: #f1f5f9;
    border-radius: 10px;
}
.cmd-mode {
    height: 36px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: #475569;
    font-size: 13px;
    line-height: 36px;
    cursor: pointer;
    transition: background-color 180ms ease, color 180ms ease, box-shadow 180ms ease;
}
.cmd-mode:hover {
    color: #0f172a;
    background: rgba(255, 255, 255, 0.72);
}
.cmd-mode.is-active {
    background: #409eff;
    color: #ffffff;
    font-weight: 600;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.12);
}
.cmd-mode:focus-visible {
    outline: 2px solid #409eff;
    outline-offset: 2px;
}
@media (prefers-reduced-motion: reduce) {
    .cmd-mode {
        transition: none;
    }
}
.cmd-stage {
    height: 168px;
}
.cmd-stage ::v-deep .el-textarea,
.cmd-stage ::v-deep .el-textarea__inner {
    height: 100%;
}
.cmd-program {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    align-content: start;
}
.cmd-program-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 10px 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #f8fafc;
    text-align: left;
    cursor: pointer;
    transition: border-color 180ms ease, background-color 180ms ease, box-shadow 180ms ease;
}
.cmd-program-card:hover {
    border-color: #93c5fd;
    background: #ffffff;
}
.cmd-program-card.is-active {
    border-color: #409eff;
    background: #ecf5ff;
    box-shadow: inset 0 0 0 1px #409eff;
}
.cmd-program-card:focus-visible {
    outline: 2px solid #409eff;
    outline-offset: 2px;
}
.cmd-program-no {
    font-size: 12px;
    line-height: 16px;
    color: #64748b;
}
.cmd-program-card.is-active .cmd-program-no {
    color: #409eff;
    font-weight: 600;
}
.cmd-program-name {
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    color: #0f172a;
}
.cmd-program-desc {
    font-size: 12px;
    line-height: 18px;
    color: #64748b;
}
@media (prefers-reduced-motion: reduce) {
    .cmd-program-card {
        transition: none;
    }
}
</style>
